import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { RootState } from '../store/store';

import { showAlert, hideAlert } from '../store/slices/alerts/alertsSlice';

const useAlerts = () => {
  const dispatch = useDispatch();
  const { type, title, message, isVisible } = useSelector(
    (state: RootState) => state.alerts
  );

  const show = useCallback(
    (type: string, title: string, message: string) => {
      dispatch(showAlert({ type, title, message }));
    },
    [dispatch]
  );

  const hide = useCallback(() => {
    dispatch(hideAlert());
  }, [dispatch]);

  return {
    type,
    title,
    message,
    isVisible,
    show,
    hide,
  };
};

export default useAlerts;
